// @flow

import type { State } from "@store/reducers";
import type { ApprovableContainer } from "@modules/service/types";
import type { NurseDeclinedReason } from "@modules/service/reducer/nurse-declined-reasons/types";

export type GetNurseDeclinedReasonsList = (state: State) => Array<NurseDeclinedReason>;
export type GetSchemaResponseType = (state: State) => Object | null;
export type GetNurseDeclinedReasonsEnabled = (state: State) => boolean;

// NURSE DECLINED REASONS CRUD

export const getNurseDeclinedReasonsList = (state: State) =>
  state.service.nurseDeclinedReasons.list;

export const getCurrentNurseDeclinedReason = (
  state: State,
): ?ApprovableContainer<NurseDeclinedReason> => state.service.nurseDeclinedReasons.current;

// NURSE DECLINED REASONS SCHEMA

export const getNurseDeclinedReasonSchema: GetSchemaResponseType = state =>
  state.service.nurseDeclinedReasons.schema;

// NURSE DECLINED REASONS CONFIG

export const getNurseDeclinedReasonsEnabled: GetNurseDeclinedReasonsEnabled = state =>
  state.service.nurseDeclinedReasons.configuration.enabled;

// NURSE DECLINED REASONS MODALS

export const getShowNurseDeclinedReasonAddModal = (state: State): boolean =>
  state.service.nurseDeclinedReasons.modals.showAddModal;

export const getShowNurseDeclinedReasonEditModal = (state: State): boolean =>
  state.service.nurseDeclinedReasons.modals.showEditModal;

export const getNurseDeclinedReasonsLoading = (state: State): boolean =>
  state.service.nurseDeclinedReasons.isLoading;
